import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'
import useAddressSelector from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/AddressSelector/useAddressSelector'
import PropTypes from 'prop-types'
import CopyEndEnhancer from '@/shared/components/SDComponentsNewDesign/CopyEndEnhancer/CopyEndEnhancer'
import { SelectCopyOverlay, SelectWrapper } from '@/shared/theme/styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { PulseSelectCopyOverlay } from './styled-components'
import useClientTabMissingFields from '@/containers/SubscriptionFormPageNew/SubscriptionForm/ClientTabStatus/useClientTabMissingFields'

const AddressSelectorField = ({ module, validations, saleName, hidden }) => {
  const isPulse = usePulseScope()
  const isMissing = useClientTabMissingFields()
  if (hidden) return null
  const { t, label, addressesList, addressSelectorHandler, selectedValue, addressError, isEditable, getOptionLabel } =
    useAddressSelector(module, validations, saleName)

  if (!addressesList?.length) {
    return module === 'client' ? null : <p>{t('common:no_addresses_available')}</p>
  }

  const selectedLabel = selectedValue && addressesList ? addressesList[selectedValue] : null
  const CopyOverlay = isPulse ? PulseSelectCopyOverlay : SelectCopyOverlay

  return (
    <SDFormControl plainLabel error={addressError}>
      <SelectWrapper>
        <SDSelect
          label={label}
          disabled={!isEditable}
          optionsList={addressesList}
          onChangeHandler={params => addressSelectorHandler(params.option?.id)}
          selectedValue={selectedValue}
          placeholder={t('common:choose')}
          getOptionLabel={getOptionLabel}
          missing={isMissing('addressChoice')}
        />
        <CopyOverlay>
          <CopyEndEnhancer value={selectedLabel} />
        </CopyOverlay>
      </SelectWrapper>
    </SDFormControl>
  )
}

AddressSelectorField.propTypes = {
  module: PropTypes.string,
  validations: PropTypes.object,
  saleName: PropTypes.string,
  hidden: PropTypes.bool,
}

export default AddressSelectorField
